import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.ax{border-radius:1.25rem;}.ssr-plugin'
import '.u{border:var(--border-subtle);}.ssr-plugin'
import '.br{padding:1.5rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.d{gap:1rem;}.ssr-plugin'
import '.jb{height:1px;}.ssr-plugin'
import '.dp{background-color:var(--gray-100);}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Text } from '@app/components/core/typography/Text'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { faHeart, faComment } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export interface DiscussionCardProps {
  authorName: string
  authorAvatar?: string
  postedIn?: string
  date: string
  content: string
  likes: number
  replies: number
  onClick?: () => void
  style?: Style
}

export const DiscussionCard = ({
  authorName,
  authorAvatar,
  postedIn,
  date,
  content,
  likes,
  replies,
  onClick,
  style,
}: DiscussionCardProps) => {
  return (
    <styled.div className="t ax u br a b d"
      data-testid="discussion-card"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
    >
      {/* Header Section */}
      <Row gap="0.75rem" style={{ alignItems: 'flex-start' }}>
        <Avatar size="small" image={authorAvatar} labelSource={authorName} />
        <Column gap="0.25rem" style={{ flex: 1 }}>
          <Text.Medium
            isBold={true}
            style={{
              color: 'var(--brand-secondary)',
              lineHeight: '1.4',
            }}
          >
            {authorName}
          </Text.Medium>
          {postedIn && (
            <Text.Small
              style={{
                color: 'var(--brand-secondary)',
                lineHeight: '1.4',
              }}
            >
              posted in {postedIn}
            </Text.Small>
          )}
          <Text.Small
            style={{
              color: 'var(--gray-300)',
              lineHeight: '1.4',
            }}
          >
            {date}
          </Text.Small>
        </Column>
      </Row>

      {/* Content Section */}
      <Text.Medium
        style={{
          color: 'var(--brand-secondary)',
          lineHeight: '1.75rem',
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {content}
      </Text.Medium>

      {/* Separator Line */}
      <div className="jb dp n"
      />

      {/* Footer Section */}
      <Row
        gap="1.5rem"
        style={{
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        {/* Likes */}
        <Row gap="0.5rem" style={{ alignItems: 'center' }}>
          <FontAwesomeIcon
            icon={faHeart}
            style={{
              color: 'var(--brand-secondary)',
              width: '1rem',
              height: '1em',
            }}
          />
          <Text.Small
            style={{
              color: 'var(--brand-secondary)',
            }}
          >
            {likes} {likes === 1 ? 'like' : 'likes'}
          </Text.Small>
        </Row>

        {/* Replies */}
        <Row gap="0.5rem" style={{ alignItems: 'center' }}>
          <FontAwesomeIcon
            icon={faComment}
            style={{
              color: 'var(--brand-secondary)',
              width: '1rem',
              height: '1em',
            }}
          />
          <Text.Small
            style={{
              color: 'var(--brand-secondary)',
            }}
          >
            {replies} {replies === 1 ? 'Reply' : 'Replies'}
          </Text.Small>
        </Row>
      </Row>
    </styled.div>
  )
}
